import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminOpenSeasonService } from '@services/adminOpenSeasonService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminOpenSeasonsIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminOpenSeasonService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminOpenSeasonService: AdminOpenSeasonService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-open-seasons-new', this.dom, () => {
            this.adminOpenSeasonService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminOpenSeasonService,
            {
                entityKey: 'open_seasons',
                fetchData: (params) =>
                    this.adminOpenSeasonService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (openSeason) => {
                        this.adminOpenSeasonService
                            .editDialog(openSeason, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminOpenSeasonsIndexController = app.controller(
    'adminOpenSeasonsIndexController',
    AdminOpenSeasonsIndexController,
);
